"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'ai.com.choose_model': 'Scegli modello',
    'ai.com.choose_provider': 'Scegli provider',
    'ai.com.choose_avatar': 'Scegli avatar',
};
